module.exports = __webpack_public_path__ + "img/1.d63c5810.png";